import { createContext } from 'react';

import { RffControlsGroupState } from './types';

export const RffControlsGroupContext = createContext<RffControlsGroupState>({
  disabled: false,
});
